import { render, staticRenderFns } from "./TabLayout.vue?vue&type=template&id=79f5ef71"
import script from "./TabLayout.vue?vue&type=script&lang=js"
export * from "./TabLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports